!function(root, app) {
    app.events = app.events || {};
    app.events.halloweenTerror = app.events.halloweenTerror || {};
    app.events.halloweenTerror = {
        init: function() {
            this.defineProps();
            this.setupOverviewParallax();
        },
        defineProps: function() {
            //page containers and elements
            this.$eventLogoContainer = $('[data-js="event-logo"]');
            this.$eventOverviewForegroundImageLeft = $('[data-js="event-overview-foreground-image-left"]');
            this.$eventOverviewForegroundImageRight = $('[data-js="event-overview-foreground-image-right"]');
            this.$eventOverviewPlayIcon = $('[data-js="overview-play-button"]');
        },
        setupOverviewParallax: function() {
            this.$eventLogoContainer.verticalParallax(.25);
            this.$eventOverviewForegroundImageLeft.verticalParallax(.4);
            this.$eventOverviewForegroundImageRight.verticalParallax(.6);
            this.$eventOverviewPlayIcon.verticalParallax(.5);
        }
    };
}(this, this.app);
